// Base
import Head from 'next/head'

// Components
import MainLayout from '@components/v25/es/MainLayout'
import LogoBanner from '@components/v25/es/logo-banner/LogoBanner'
import FAQ from '@components/v25/es/faq/FAQ'

// Sections
import HomepageWrapper from '@sections/v25/es/ft1/homepage/HomepageWrapper'
import RecentDeals from '@sections/v25/es/ft1/homepage/recent-deals/RecentDeals'
import HowItWorksWrapper from '@sections/v25/es/ft1/homepage/how-it-works/HowItWorksWrapper'
import CustomerExperiences from '@sections/v25/es/ft1/homepage/customer-experiences/CustomerExperiences'
import FacebookReviews from '@sections/v25/es/ft1/homepage/facebook-reviews/FacebookReviews'
import InternationalTripWrapper from '@sections/v25/es/ft1/homepage/international-trip/InternationalTripWrapper'

export default function Home() {
  return (
    <>
      <Head>
        <title>RatePunk Premium</title>
        <meta name="description" content="RatePunk Premium" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <MainLayout backgroundColor="#FCF8FC">
        <HomepageWrapper />

        <RecentDeals />

        <LogoBanner />

        <HowItWorksWrapper />

        <CustomerExperiences />

        <FacebookReviews />

        <FAQ theme="black" />

        <InternationalTripWrapper />
      </MainLayout>
    </>
  )
}
